import React from 'react';
import LogoMark from './LogoMark';

const Footer = () => {
  return (
    <footer className="bg-black py-16 border-t border-zinc-900 text-center" data-testid="footer">
      <div className="container mx-auto px-4">
        <a href="#home" data-testid="footer-logo" className="inline-flex items-center gap-3 mb-8 group">
          <LogoMark size={34} className="transition-transform duration-500 group-hover:-rotate-6" />
          <span className="text-left leading-none">
            <span className="block font-display text-lg font-semibold tracking-wide text-white">İSKENDERUN</span>
            <span className="block text-[10px] tracking-[0.45em] text-yellow-500 font-semibold mt-1">KONAKLAMA</span>
          </span>
        </a>

        <div className="flex justify-center space-x-6 mb-8 flex-wrap gap-y-4">
          <a href="#home" data-testid="footer-link-anasayfa" className="text-zinc-400 hover:text-yellow-500 transition-colors">Ana Sayfa</a>
          <a href="#gallery" data-testid="footer-link-daireler" className="text-zinc-400 hover:text-yellow-500 transition-colors">Daireler</a>
          <a href="#gallery" data-testid="footer-link-galeri" className="text-zinc-400 hover:text-yellow-500 transition-colors">Galeri</a>
          <a href="#contact" data-testid="footer-link-iletisim" className="text-zinc-400 hover:text-yellow-500 transition-colors">İletişim</a>
        </div>

        <p className="text-zinc-600 text-sm">
          &copy; {new Date().getFullYear()} İskenderun Konaklama Hotel. Tüm hakları saklıdır.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
